export const BoxDefaultProps = {
    dataId: 'boxComponent',
    testId: '',
    isScrollAttribute: false,
    tagName: 'div',
    dataSelectorId: 'box'
  };
  export const ContainerDefaultProps = {
    dataId: 'containerComponent',
    testId: '',
    isScrollAttribute: false,
    isCover: true,
    alignBox: 'column',
    tagName: 'div',
    dataSelectorId: 'container'
  };